import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

interface RoleBasedContentProps {
  roles: string[];
  component: React.ReactElement;
}

export const RoleBasedContent: React.FC<RoleBasedContentProps> = ({ roles, component, ...props }) => {
  const { profile } = useSelector((state: RootState) => state.auth);
  const userRole = profile?.role.toLowerCase() || '';

  if (profile && roles.includes(userRole)) {
    return React.cloneElement(component, { ...props });
  }
  return null;
};
